import { useMemo } from "react";
import { motion } from "framer-motion";

// state: "idle" | "listening" | "processing" | "speaking"
const GLOW = {
  idle: "rgba(34,211,238,0.55)",
  listening: "rgba(0,240,255,0.9)",
  processing: "rgba(255,184,0,0.85)",
  speaking: "rgba(0,240,255,0.95)",
};
const CORE_ANIM = { scale: [0.96, 1.04, 0.96] };
const CORE_TRANSITION = { duration: 3, repeat: Infinity, ease: "easeInOut" };

export const AriaOrb = ({ state = "idle", size = 220 }) => {
  const glow = GLOW[state] || GLOW.idle;
  const reactive = state === "listening" || state === "speaking";

  const haloAnim = useMemo(
    () => ({ scale: reactive ? [1, 1.18, 1] : [0.95, 1.05, 0.95], opacity: [0.5, 0.85, 0.5] }),
    [reactive]
  );
  const haloTransition = useMemo(
    () => ({ duration: reactive ? 1.1 : 4, repeat: Infinity, ease: "easeInOut" }),
    [reactive]
  );

  return (
    <div
      data-testid="aria-orb"
      data-state={state}
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <motion.div
        className="absolute rounded-full blur-2xl mix-blend-screen"
        style={{ width: size, height: size, background: glow }}
        animate={haloAnim}
        transition={haloTransition}
      />
      <div
        className={`absolute rounded-full border-2 border-transparent ${
          state === "processing" ? "animate-spin-slow" : ""
        }`}
        style={{
          width: size * 0.72,
          height: size * 0.72,
          borderTopColor: "#FFB800",
          borderRightColor: "rgba(0,240,255,0.4)",
          opacity: state === "processing" ? 1 : 0.25,
        }}
      />
      <motion.div
        className="absolute rounded-full"
        style={{
          width: size * 0.5,
          height: size * 0.5,
          background: "radial-gradient(circle at 35% 30%, #a5f3fc, #06b6d4 45%, #0e2a44 100%)",
          boxShadow: `0 0 40px ${glow}, inset 0 0 30px rgba(0,240,255,0.4)`,
        }}
        animate={CORE_ANIM}
        transition={CORE_TRANSITION}
      />
      <div
        className="absolute rounded-full blur-md"
        style={{ width: size * 0.22, height: size * 0.22, background: "#e0fbff" }}
      />
    </div>
  );
};
